import './result-banner.styles.scss';

// A "Win" or "Loss" banner for the manager's own game, styled like the
// matchup preview's rivalry banner. game: a game document. teamId: the
// manager's team (nothing is shown when it didn't play in the game).
const ResultBanner = ({ game, teamId }) => {
    if (!teamId || !game?.winner) return null;
    const mine = game.home.id === teamId ? game.home : game.away.id === teamId ? game.away : null;
    if (!mine) return null;
    const opp = mine === game.home ? game.away : game.home;
    const won = game.winner === teamId;
    const ot = game.overtimes ? ` (${game.overtimes > 1 ? `${game.overtimes}OT` : 'OT'})` : '';
    return (
        <div className={`result-banner ${won ? 'won' : 'lost'}`} role='status'>
            <div className='rb-plate'>
                <span className='rb-kicker'>{mine.abbr ?? mine.name} {won ? 'beat' : 'fell to'} {opp.abbr ?? opp.name}</span>
                <span className='rb-title'>{won ? 'Win' : 'Loss'}</span>
                <span className='rb-note'>{mine.score}-{opp.score}{ot}</span>
            </div>
        </div>
    );
}

export default ResultBanner
